export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", icon: "ri-t-shirt-line" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", icon: "ri-windy-line" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", icon: "ri-pantone-line" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", icon: "ri-glasses-line" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", icon: "ri-box-3-line" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", icon: "ri-trophy-line" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", icon: "ri-brush-line" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", icon: "ri-handbag-line" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", icon: "ri-link" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", icon: "ri-drop-line" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", icon: "ri-more-line" },
];

export const whyChooseItems = [
  {
    title: "Product Discovery",
    description: "Find trending products from multiple categories organized in easy-to-navigate spreadsheets. Our Sugargoo Spreadsheet database helps you discover hidden gems across thousands of listings.",
    icon: "ri-search-eye-line",
  },
  {
    title: "Quality Research",
    description: "Understand products before purchasing with detailed QC photos, sizing guides, and community feedback. Make informed decisions with our comprehensive Sugargoo Spreadsheet resources.",
    icon: "ri-file-search-line",
  },
  {
    title: "Shopping Education",
    description: "Learn Sugargoo step by step from beginner basics to advanced techniques. Our guides cover everything from account setup to warehouse management and international shipping.",
    icon: "ri-book-open-line",
  },
  {
    title: "Cost Optimization",
    description: "Compare shipping options, find discount codes, and discover money-saving strategies. Our Sugargoo Spreadsheet includes cost analysis tools to help you maximize value.",
    icon: "ri-money-dollar-circle-line",
  },
];

export const guideItems = [
  { title: "Sugargoo Review 2026", description: "In-depth platform analysis, pros and cons, user experiences, and honest rating.", icon: "ri-star-line", slug: "/sugargoo-review" },
  { title: "Shipping Cost Guide", description: "Complete breakdown of shipping methods, rates, delivery times, and cost-saving tips.", icon: "ri-ship-line", slug: "/sugargoo-shipping-cost" },
  { title: "Coupon & Discount Guide", description: "Latest working coupons, seasonal promotions, and strategies to save money.", icon: "ri-coupon-line", slug: "/sugargoo-coupon" },
  { title: "Warehouse Explained", description: "How Sugargoo warehouse works, storage time, QC process, and consolidation tips.", icon: "ri-store-2-line", slug: "/sugargoo-warehouse" },
  { title: "Is Sugargoo Legit?", description: "Safety analysis, company background, buyer protection, and risk assessment.", icon: "ri-shield-check-line", slug: "/is-sugargoo-legit" },
];

export const comparisonData = [
  { feature: "Finding Products", manual: "Hours of manual browsing across multiple Chinese platforms", spreadsheet: "Organized database with direct links and QC photos" },
  { feature: "Product Comparison", manual: "Open dozens of browser tabs and compare manually", spreadsheet: "Side-by-side comparison in structured format" },
  { feature: "Time Efficiency", manual: "Days or weeks to build a shopping list", spreadsheet: "Ready-to-use lists in minutes" },
  { feature: "Beginner Friendly", manual: "Steep learning curve, confusing interfaces", spreadsheet: "Curated picks with clear categories and descriptions" },
  { feature: "Research Quality", manual: "Limited to individual browsing experience", spreadsheet: "Community-vetted selections with quality ratings" },
];